import * as React from 'react';
import * as Yup from 'yup';
import { Field, Formik, FieldProps, FormikProps, FormikValues } from 'formik';
import { StyledForm, FieldRow, StyledFormSelect, Button } from '../../components';
import Span from '../../typography/Span';
import { formatFormValues } from '../../utils/helpers';
import { withRouter, RouteComponentProps } from 'react-router';

const APPLICATION_TYPE = [
  { label: 'Vehicle Access', value: 'VEHICLE_ACCESS' },
  { label: 'Security Access', value: 'SECURITY_ACCESS' },
  { label: 'Shuttle Service', value: 'SHUTTLE_SERVICE' },
  { label: 'Gym Membership', value: 'GYM_MEMBERSHIP' },
];

const ApplicationTypeValidation = Yup.object().shape({
  applicationType: Yup.mixed().required('Required'),
});

type ApplicationTypeFormValues = {
  applicationType: number;
};

type Props = RouteComponentProps<MatchParams> & {
  mutation?: any;
  error?: any;
  buttonText?: string;
  loading?: boolean;
  initialValues?: FormikValues;
  stakeholderID?: string;
};

type MatchParams = {
  stakeholderID: string;
};

interface FormattedValues {
  applicationType?: string;
}

class ApplicationTypeForm extends React.Component<Props> {
  onProceed = (type: string | undefined) => {
    const id = this.props.match.params.stakeholderID;
    switch (type) {
      case 'VEHICLE_ACCESS':
        return <div />;
      case 'SECURITY_ACCESS':
        return this.props.history.push(`/stakeholders/${id}/applications/security-access`);
      case 'SHUTTLE_SERVICE':
        return <div />;
      case 'GYM_MEMBERSHIP':
        return <div />;
      default:
        return <div />;
    }
  };
  public render() {
    return (
      <Formik
        validationSchema={ApplicationTypeValidation}
        initialValues={
          this.props.initialValues
            ? this.props.initialValues
            : {
                applicationType: undefined,
              }
        }
        onSubmit={(values: ApplicationTypeFormValues) => {
          const formattedValues: FormattedValues = formatFormValues(values);
          this.onProceed(formattedValues.applicationType);
        }}
        render={(formikProps: FormikProps<ApplicationTypeFormValues>) => {
          return (
            <StyledForm flexDirection="row">
              <FieldRow>
                <Field
                  name="applicationType"
                  render={({ field }: FieldProps<ApplicationTypeFormValues>) => (
                    <StyledFormSelect
                      {...field}
                      field={field}
                      label="Which application would you like to fill out?"
                      form={formikProps}
                      options={APPLICATION_TYPE}
                    />
                  )}
                />
              </FieldRow>
              {this.props.error && (
                <Span width="100%" textAlign="center" color="error" mb={3}>
                  {this.props.error.message.replace('GraphQL error:', '').trim()}
                </Span>
              )}
              <Button mb={1} type="submit" text="Proceed" isLoading={this.props.loading} />
            </StyledForm>
          );
        }}
      />
    );
  }
}

export default withRouter(ApplicationTypeForm);



// WEBPACK FOOTER //
// ./src/forms/stakeholders/ApplicationTypeForm.tsx